export enum InsightsInformationType {
  GENERAL_INFO = 'GeneralInfo',
  EXPERIENCE = 'Experience',
  SOCIAL_PRESENCE = 'SocialPresence',
  KEY_TOPICS = 'KeyTopics',
  CURRENT_COMPANY = 'CurrentCompany',
  JOB_OPENINGS = 'JobOpenings',
  NEWS = 'News',
  FUNDING_ROUNDS = 'FundingRounds',
}
